import { appWerklijstG4Ar } from './golf4App.ar.js';
// Arabisch (ar), werklijstApp: zelfde vorm als werklijstApp.nl.ts (golf 3-integratie). Alleen de
// schermteksten; de punten zelf blijven Nederlands (docs/werklijst.json).
export const appWerklijstAr = {
    ...appWerklijstG4Ar,
    title: 'قائمة العمل',
    subtitle: 'لك وحدك بصفتك المسؤول · حُدّثت {when}',
    progress: '{done} من {total} جاهزة',
    progressLabel: 'التقدم: {done} من {total} بنود جاهزة',
    progressRegion: 'التقدم',
    status: {
        waiting_on_you: 'بانتظارك',
        in_progress: 'قيد العمل',
        planned: 'مخطط',
        later: 'لاحقًا',
        done: 'جاهز',
    },
    filterAll: 'الكل',
    filterLabel: 'عرض',
    filterActive: 'ترى الآن فقط: {status}',
    showAll: 'عرض الكل',
    needsYou: 'ما أحتاجه منك',
    needsYouCount: {
        zero: 'لا يوجد بند بانتظارك.',
        one: 'هناك بند واحد بانتظارك.',
        two: 'هناك بندان بانتظارك.',
        few: 'هناك {count} بنود بانتظارك.',
        many: 'هناك {count} بندًا بانتظارك.',
        other: 'هناك {count} بند بانتظارك.',
    },
    show: 'عرض',
    doneAt: 'جاهز في {when}',
    whatIsIt: 'ما هذا؟',
    yourAction: 'ماذا عليك أن تفعل؟',
    numberLabel: 'البند {n} من ملاحظاتك',
    groupCount: '{done} من {total} جاهزة',
    emptyTitle: 'لا شيء بهذه الحالة',
    emptyBody: 'اختر حالة أخرى في الأعلى، أو الكل.',
    unavailable: 'تعذّرت قراءة قائمة العمل الآن. حاول مرة أخرى بعد قليل.',
};
//# sourceMappingURL=werklijstApp.ar.js.map